/** @jsxImportSource @emotion/react */
import { FC, JSX, ReactNode } from 'react'
import { css, Theme, useTheme } from '@emotion/react'
import { useRpBreakpoint } from '../../core/theme'

type TypographyProps = {
  variant: keyof Theme['rpTheme']['typography']
  color?: keyof Theme['rpTheme']['colors']
  className?: string
  children?: ReactNode
  as?: keyof JSX.IntrinsicElements
}

export const Typography: FC<TypographyProps> = (props) => {
  const {
    variant,
    color = 'white',
    className,
    children,
    as: Component = 'p',
  } = props
  const theme = useTheme() as Theme
  const breakpoint = useRpBreakpoint()

  const typographyStyles = theme.rpTheme.typography[variant]
  const colorVariant = theme.rpTheme.colors[color]
  const fontSize = typographyStyles.fontSize[breakpoint]

  const style = css`
    margin: 0;
    color: ${colorVariant};
    font-weight: ${typographyStyles.fontWeight};
    line-height: 1;
    font-size: ${fontSize};
  `

  return (
    <Component className={className} css={style}>
      {children}
    </Component>
  )
}
